import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {CultureModel} from '../../../models/localization-and-pricing/culture.model';
import {StringExtensionModel} from '../../../models/extensions/string-extension.model';
import {NavigationModel} from '../../../models/localization-and-pricing/navigation.model';
import {DropdownModel} from '../../../models/component/dropdown.model';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit, AfterViewInit {

  hidden: boolean; // To adapt with the burger menu of the navbarre
  currentFeature: string;

  selectionDropdown: DropdownModel[] = [
    new DropdownModel('game', 'lp2.footer.game', './assets/land-images/battle-monster-ipad.png'),
    new DropdownModel('books', 'lp2.features.books.titleMenu', './assets/land-images/Books.png'),
    new DropdownModel('monitor', 'lp2.landing.evolytesPart.monitorTitle', './assets/land-images/MonitorAllDevices.png')
  ];

  scrollingDiv: HTMLDivElement;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {

    this.hidden = true;
    this.currentFeature = 'game';
    if (this.router.url.includes('features/') === false) {
      this.router.navigate(NavigationModel.getHomeURLPaths(['features', 'game']));
    }

    if (this.router.url.includes('features/books')) {
      this.currentFeature = 'books';
    } else if (this.router.url.includes('features/game')) {
      this.currentFeature = 'game';
    } else if (this.router.url.includes('features/monitor')) {
      this.currentFeature = 'monitor';
    }

    this.scrollingDiv = document.getElementById('scroller') as HTMLDivElement;

  }

  ngAfterViewInit() {

    this.router.events.subscribe((event) => {

      if (event instanceof NavigationEnd) {

        if (this.router.url.includes('features/books')) {
          this.currentFeature = 'books';
        } else if (this.router.url.includes('features/game')) {
          this.currentFeature = 'game';
        } else if (this.router.url.includes('features/monitor')) {
          this.currentFeature = 'monitor';
        }

        this.scrollingDiv.scrollTop = 0;

      }

    });

  }

  setHidden() {
    this.hidden = !this.hidden;
  }

  setCurrentFeature(feature) {

    this.currentFeature = feature;

    switch (feature) {
      case 'game':
        this.router.navigate(NavigationModel.getHomeURLPaths(['features', 'game']));
        break;

      case 'books':
        this.router.navigate(NavigationModel.getHomeURLPaths(['features', 'books']));
        break;

      case 'monitor':
        this.router.navigate(NavigationModel.getHomeURLPaths(['features', 'monitor']));
        break;

      default:
        this.router.navigate(NavigationModel.getHomeURLPaths(['features', 'game']));
    }

  }

}
